import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { ModalResponse } from 'src/app/core/services/modal-response';
import { ModalResult } from 'src/app/core/services/modal-result';
import { ModalService } from 'src/app/core/services/modal.service';
import { ToastMessagesService } from 'src/app/core/services/toast-messages.service';
import { MembreService } from 'src/app/membres/services/membre.service';

@Component({
  selector: 'app-saisie-membre',
  templateUrl: './saisie-membre.component.html',
  styleUrls: ['./saisie-membre.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SaisieMembreComponent implements OnInit {
  form: FormGroup;
  saving = false;
  @Output() newMembreId = new EventEmitter<number>();

  constructor(
    private modalService: ModalService,
    public membreService: MembreService,
    private toastMessagesService: ToastMessagesService,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      id: null,
      nom: [null, [Validators.required]],
      prenom: [null, [Validators.required]],
      // suffixe: [{ value: null, disabled: true }],
      titreId: [null],
      comptes: [[]],
    });
  }

  save() {
    if (this.form.valid) {
      this.saving = true;
      this.membreService
        .save(this.form.getRawValue(), [])
        .pipe(finalize(() => (this.saving = false)))
        .subscribe((r) => {
          const message = r['msg'];
          if (message) {
            const modalResponse = new ModalResponse();
            modalResponse.onModalReply$.subscribe((modalResult) => {
              if (modalResult === ModalResult.ok) {
                this.saving = true;
                this.membreService
                  .save(this.form.getRawValue(), [...r['forcingKeys']])
                  .pipe(finalize(() => (this.saving = false)))
                  .subscribe((rep) => this.onSaveSuccess(rep));
              }
            });
            this.modalService.confirmWarning(
              'Demande de confirmation',
              `${message} \n Confirmer l'enregistrement ?`,
              'Oui',
              'Non',
              modalResponse,
            );
          } else {
            this.onSaveSuccess(r);
          }
        });
    }
  }

  onSaveSuccess(reponse: any) {
    this.newMembreId.emit(+reponse['id']);
    this.form.reset();
    this.toastMessagesService.showSuccess('Membre enregistré avec succès');
  }
}
